// Misma lógica que estudiantes: pendientes primero (último mensaje del otro), luego por fecha
import sortConversationsBase from '../../../estudiantes/chat/components/sortConversations';

const sortConversations = (list, currentUserId) => sortConversationsBase(list, currentUserId);

export default sortConversations;
